import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import Dialog from '~/components/Dialog'
import { Icon, Message, Segment } from 'semantic-ui-react'
import InfoPopup from '~/components/InfoPopup'
import { GeneralEl } from './style'
import { RouteTypes } from '~/routes/constants'

interface Props {
  isOpen: boolean
  handleClose: () => void
}

const WelcomeModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { isOpen, handleClose } = props
  const { id } = useParams()
  const navigate = useNavigate()

  function renderPreviewFile() {
    return <div>
      <div>
        <Segment basic>
          <GeneralEl.SubTitle>{t('Welcome to the Cool Farm Tool dairy module')}</GeneralEl.SubTitle>
          <GeneralEl.WelcomeText>
            {t('Click the \'continue\' button below to enter data for your dairy footprint.')}
          </GeneralEl.WelcomeText>

          <GeneralEl.InfoSection>
            <GeneralEl.SubTitle>{t('Growing your own feed?')}</GeneralEl.SubTitle>
            <GeneralEl.InfoText>
              {t('On-farm pasture used for grazing needs to be completed through this dairy module. Other on-farm feed crops such as corn, small grains and soy need to be completed in the crop module. For hay and hay silage, these are best completed in the crop module. Where this is not possible (e.g. when pasture is used for both grazing and hay production) these crops may be entered in this dairy module.')}
            </GeneralEl.InfoText>
            <GeneralEl.LinkButton type='button' onClick={() => navigate(RouteTypes.COOL_FARM_ANSWER_CROP.replace(':id', id))}>
              {t('Create a crop footprint')} ↗
            </GeneralEl.LinkButton>
            <GeneralEl.InfoText style={{ marginTop: '1em' }}>
              {t('After completing the crop footprint, click on the \'More\' button, select a relevant base feed item to make the crop footprint available as a feed option in this dairy module.')}
            </GeneralEl.InfoText>
          </GeneralEl.InfoSection>

          <Message icon style={{ marginTop: '2em', backgroundColor: '#fffaf3', color: '#573a08', height: 'fit-content', display: 'block' }}>
            <div style={{ fontWeight: 'bold' }}>
              <Icon name='info circle' style={{ fontSize: '1.2em' }}/>
              {t('Important Information')}
            </div>
            <p>{t('Please ensure all required fields are completed accurately to get the most precise footprint calculation.')}</p>
          </Message>
        </Segment>
      </div>
    </div>
  }

  function renderHeader() {
    return <GeneralEl.Title>
      {t('General information')}
      <InfoPopup
        style={{ minWidth: 450 }}
        position={'right center'}
        content={<section aria-labelledby='tool-requirements'>
          <h2 id='tool-requirements'>
            {t('To complete the Tool, you will need data for your chosen 12 month period on:')}
          </h2>
          <ul>
            <li>{t('Milk production')}</li>
            <li>{t('Number of animals, by category')}</li>
            <li>{t('Time spent grazing, and grassland fertilisation')}</li>
            <li>
              {t('Feed volumes; either (1) Dry Matter Intake per category OR (2) feed components for entire herd.')}
            </li>
            <li>{t('Type of manure management')}</li>
            <li>{t('Energy use data (e.g. electricity, gas)')}</li>
            <li>{t('Transportation mode and distances')}</li>
          </ul>
        </section>}
        styleIcon={{ fontSize: '1.2em', cursor: 'pointer' }}
    />
    </GeneralEl.Title>
  }

  return <Dialog
    textHeader={renderHeader()}
    heightContent={'80%'}
    heightDialog={'60%'}
    isDialogOpen={isOpen}
    noScrollingContent={false}
    style={{ width: '50%' }}
    type={'preview'}
    handleClose={() => handleClose()}
    textContent={renderPreviewFile()}
  />
}
export default WelcomeModal